var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',[_c('ListHomeOwnerConversations',{attrs:{"ownerAuthor":_vm.currentOwnerName,"authenticatedUser":_vm.authUser.name,"ownerID":parseInt(_vm.ownerID)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }